import styled from "styled-components"

const TitleContainer = styled.div.attrs(props => ({
  className: "mx-4 sm:mx-12 md:mx-12 lg:mx-12 flex flex-row text-2xl md:text-4xl lg:text-5xl font-impact items-center" + props.className
}))``

export {
  TitleContainer
}